// import React, { useEffect, useState } from "react";
// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Tooltip,
//   Legend
// } from 'chart.js';
// import { Bar } from 'react-chartjs-2';
// import dashboardService from "../Services/dashboardService";

// ChartJS.register(
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Tooltip,
//   Legend
// );

// const BarChart = () => {
//   const data = {
//     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
//     datasets: [
//       {
//         label: 'Orders',
//         data: [400, 300, 200, 278, 189],
//         backgroundColor: '#22c55e',
//         barPercentage: 0.5,
//         categoryPercentage: 0.5,
//       },
//       {
//         label: 'Purchases',
//         data: [240, 139, 270, 390, 480],
//         backgroundColor: '#fb923c',
//         barPercentage: 0.5,
//         categoryPercentage: 0.5,
//       },
//       {
//         label: 'Expenses',
//         data: [374, 221, 229, 200, 218],
//         backgroundColor: '#ef4444',
//         barPercentage: 0.5,
//         categoryPercentage: 0.5,
//       },
//     ],
//   };
//   const [statsData, setStatsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   useEffect(() => {
//     const getTotals = async () => {
//  try {
//    setLoading(true);
//    const response = await dashboardService.fetchStats();
//    setStatsData(response.purchase);
//    setLoading(false);
//  } catch { }
// };
// getTotals();

// }, []);
//   const options = {
//     responsive: true,
//     maintainAspectRatio: false, // this is key for responsiveness
//     plugins: {
//       legend: {
//         position: 'top',
//       },
//       tooltip: {
//         mode: 'index',
//         intersect: false,
//       },
//     },
//     scales: {
//       x: {
//         categoryPercentage: 0.3,
//         barPercentage: 0.3,
//       },
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   return (
//     <div className="w-full h-full">
//     <Bar data={data} options={options} />
//   </div>
//   );
// };

// export default BarChart;

import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import dashboardService from "../Services/dashboardService";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const BarChart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTotals = async () => {
      try {
        setLoading(true);
        const response = await dashboardService.fetchTotals();
        const purchase = response.purchase || [];
  
        const today = new Date();
        const fifteenDaysAgo = new Date();
        fifteenDaysAgo.setDate(today.getDate()  - 21); // 14 days ago + today = 15 days total
  
        // Filter purchase data for the last 15 days
        const filtered = purchase.filter(item => {
          const itemDate = new Date(item.day);
          return itemDate >= fifteenDaysAgo && itemDate <= today;
        });
  
        // Sort by day ascending just in case
        filtered.sort((a, b) => new Date(a.day) - new Date(b.day));
  
        // Map filtered data to chart labels and datasets
        const labels = filtered.map(item =>
          new Date(item.day).toLocaleDateString('en-GB')
        );
  
        const orders = filtered.map(item => parseFloat(item.order_total_vat) || 0);
        const purchases = filtered.map(item => parseFloat(item.purchase_total_amount) || 0);
        const expenses = filtered.map(item => parseFloat(item.expense_total_amount) || 0);
  
        setChartData({
          labels,
          datasets: [
            {
              label: 'Orders',
              data: orders,
              backgroundColor: '#22c55e',
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
            {
              label: 'Purchases',
              data: purchases,
              backgroundColor: '#fb923c',
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
            {
              label: 'Expenses',
              data: expenses,
              backgroundColor: '#ef4444',
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
          ],
        });
  
        setLoading(false);
      } catch (error) {
        console.error("Error fetching stats:", error);
        setLoading(false);
      }
    };
  
    getTotals();
  }, []);
  
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 10, // Smaller legend text
          },
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        bodyFont: {
          size: 10, // Tooltip body font
        },
        titleFont: {
          size: 11, // Tooltip title font
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 10, // X-axis labels
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 10, // Y-axis labels
          },
        },
      },
    },
  };
  

  return (
    <div style={{ width: '100%', height: '275px' }}>
      {loading ? <p>Loading...</p> : <Bar data={chartData} options={options} />}
    </div>
  );
};

export default BarChart;
